import { useEffect, useRef, useState } from 'react'
import { Sun } from 'lucide-react'

export default function KeepScreenOn() {
  const [enabled, setEnabled] = useState(false)
  const [active, setActive] = useState(false)
  const [message, setMessage] = useState('')
  const wanted = useRef(false)
  const lock = useRef<WakeLockSentinel | null>(null)
  const pending = useRef(false)
  const supported = typeof navigator !== 'undefined' && 'wakeLock' in navigator

  useEffect(() => {
    wanted.current = enabled
    async function acquire() {
      if (!wanted.current || pending.current || lock.current || document.visibilityState !== 'visible') return
      pending.current = true
      try {
        const sentinel = await navigator.wakeLock.request('screen')
        if (!wanted.current) { await sentinel.release(); return }
        lock.current = sentinel
        setActive(!sentinel.released)
        setMessage('')
        sentinel.addEventListener('release', () => {
          if (lock.current !== sentinel) return
          lock.current = null
          setActive(false)
          if (wanted.current) setMessage('화면 유지가 일시 중단됐어요. 이 화면으로 돌아오면 다시 시도해요. 계속 중단되면 껐다 켜 주세요.')
        })
      } catch {
        setActive(false)
        setMessage('화면 유지를 켜지 못했어요. 절전 모드를 끄고 최신 Chrome에서 다시 시도해 주세요.')
      } finally { pending.current = false }
    }
    const resume = () => { void acquire() }
    if (enabled && supported) void acquire()
    document.addEventListener('visibilitychange', resume)
    return () => {
      wanted.current = false
      document.removeEventListener('visibilitychange', resume)
      const sentinel = lock.current
      lock.current = null
      setActive(false)
      if (sentinel) void sentinel.release().catch(() => {})
    }
  }, [enabled, supported])

  return <div className="screen-awake-control">
    <button className={`screen-awake-button${active ? ' is-active' : ''}`} aria-pressed={enabled} onClick={() => {
      if (!supported) { setMessage('이 브라우저는 화면 유지를 지원하지 않아요. 최신 Chrome으로 열어 주세요.'); return }
      setMessage('')
      setEnabled(value => !value)
    }}><Sun/><span>{active ? '화면 유지 켜짐' : enabled ? '화면 유지 대기 중' : '화면 계속 켜두기'}</span></button>
    {(enabled || message) && <div className="screen-awake-note" role="status">{message || (active ? '이 탭을 화면에 열어두면 꺼지지 않아요. 배터리를 사용하며, 새로고침하면 다시 켜 주세요.' : '화면 유지 권한을 요청하고 있어요.')}</div>}
  </div>
}
